import { PropsWithChildren, useEffect, useState } from "react";
import Navbar from "@components/navbar/navbar";
import * as React from "react";
import { useDispatch } from "react-redux";
import {AppDispatch, RootState} from "@src/store";
import { getPatronInfo } from "@features/user/action";
import Spinner from "@components/spinner";
import { Box, Container } from "@chakra-ui/react";
import Footer from "@components/footer";
import {setLang} from "@features/reservation/action";
import i18n from "i18next";
import {useAppSelector} from "@store/hooks";

type Props = PropsWithChildren<{}>;

const Layout = ({ children }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [render, setRender] = useState(false);
 const lang = i18n.language;

    const {websiteSettings} = useAppSelector((state: RootState) => state.websiteSettings);

    const [prevSettings, setPrevSettings] = useState({
        BYODAvailable: websiteSettings.BYODAvailable,
        reservePCAvailable: websiteSettings.reservePCAvailable,
        reservePlaceAvailable: websiteSettings.reservePlaceAvailable,
    });

    useEffect(() => {
        const hasChanged =
            prevSettings.BYODAvailable !== websiteSettings.BYODAvailable ||
            prevSettings.reservePCAvailable !== websiteSettings.reservePCAvailable ||
            prevSettings.reservePlaceAvailable !== websiteSettings.reservePlaceAvailable;

        const updatedSettings = {
            BYODAvailable: websiteSettings.BYODAvailable,
            reservePCAvailable: websiteSettings.reservePCAvailable,
            reservePlaceAvailable: websiteSettings.reservePlaceAvailable,
        };

        if (localStorage.getItem("userSettings") && hasChanged) {
            const currentSettings = JSON.parse(localStorage.getItem("userSettings") || '{}');
            const newSettings = {
                ...currentSettings,
                ...updatedSettings,
            };

            localStorage.setItem("userSettings", JSON.stringify(newSettings));
        }

        setPrevSettings(updatedSettings);

        (async () => {
            await dispatch(getPatronInfo());
            await dispatch(setLang({ userLanguage: lang.toUpperCase() }));
            setRender(true);
        })();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        websiteSettings.BYODAvailable,
        websiteSettings.reservePCAvailable,
        websiteSettings.reservePlaceAvailable,
    ]);


    if (!render) return <Spinner />;
  return (
    <>
      <Navbar />

      <Box as={"main"} pb={"68px"}>
        {children}
      </Box>

      <Box
          pos={"absolute"}
          bottom={0}
          w={"full"}
          p={"22px"}
          background={"custom.brand_primary"}
          color={"white"}
      >
        <Container
            maxW={"container.xl"}
            p={"0 32px"}
        >
          <Footer />
        </Container>
      </Box>
    </>
  );
};

export default Layout;
